<dashboard-dialog-frame [header]='header' [actions]='actions' [dialogRef]='dialogRef' icon='far fa-comment-exclamation'>

	<div style="padding: .7em .5em;">

		<!-- <p style="white-space: pre-wrap;">{{ message }}</p> -->
		<markdown style="white-space: pre-wrap;" [data]='message'></markdown>

		@if(bullets.length) {
		<div class="message-dialog-bullets-container">
			<ul>
				@for (bullet of bullets; track $index) {
				<li>{{ bullet }}</li>
				}
			</ul>
		</div>
		}

	</div>

</dashboard-dialog-frame>